<template>
  <ul class="nav" :class="classes">
    <slot />
  </ul>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'UeNav',
  props: {
    variant: {
      type: String as PropType<'tabs' | 'pills'>,
      default: 'pills',
    },
    direction: {
      type: String,
      default: 'horizontal',
    },
  },
  computed: {
    classes() {
      return [this.variantClass, this.directionClasses].join(' ')
    },
    directionClasses() {
      if (this.direction === 'vertical') {
        return 'flex-column'
      }
      return 'd-inline-flex border rounded'
    },
    variantClass() {
      return `nav-${this.variant}`
    },
  },
})
</script>

<style lang="sass" scoped>
.nav-pills
  &.flex-column
    *
      margin-bottom: 0.3rem
</style>
